import { MqttCommandDeliveryStatusType } from "../../../types/types";
import { api } from "../api";

/**
 * findMqttCommandStatusByIdResponse - Function that finds an MQTT command delivery by commandId
 * /devices/commands/{commandId}
 * method GET
 * @async-function
 */
const findMqttCommandStatusByIdResponse = async (token: string, commandId: string) => {
    const response = await api.get<MqttCommandDeliveryStatusType>(
        `/devices/commands/${commandId}`,
        {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        }
    );
    return response;
};

export default findMqttCommandStatusByIdResponse;
